<div *ngIf="displayManagerService.index$ | ngrxPush as index">
  <idp-simple-modal
    class="skymiles-landing-page-welcome-tour"
    [closeOnBackgroundClick]="false"
    [closeOnEscape]="false"
    [headerStyle]="'dark'"
    [modalStyle]="'primary'"
    [modalTitle]="content.header"
    [openWindow]="false"
    [open]="true"
    [width]="'auto'"
    [scrollModal]="!mobileScreen()"
    [showCloseButton]="false"
    [showFooter]="!mobileScreen()"
    idpAppModalfocus
    [focusOnModal]="true"
    [ariaLabelClose]="content.ariaLabels.close"
    (openChange)="notifyClose()"
  >
    <div class="skymiles-landing-page-welcome-tour__image">
      <idp-image
        [content]="
          getImage(
            content.slides[+index].desktopImage,
            content.slides[+index].mobileImage
          )
        "
      ></idp-image>
    </div>
    <idp-paginator
      *ngIf="content.slides.length !== 1"
      [paginator]="{
        index: +index,
        ariaLabels: {
          title: getAriaLabels(content.slides),
          action: content.ariaLabels.action
        },
        count: content.slides.length,
        label: {
          title: content.slides[+index].content.title,
          subtitle: content.slides[+index].content.subtitle
        }
      }"
    ></idp-paginator>
  </idp-simple-modal>
</div>
